exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans+Condensed:300);", ""]);

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\nbody {\n    font-family: 'Open Sans Condensed', sans-serif !important;\n}\n\nul { \n    list-style-type: none;  \n}\n\nul li {\n    display: inline-block;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/postcss-loader?{"ident":"postcss"}!C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2